export default __webpack_public_path__ + "static/media/back.4cb0667f.png";